// extracted by mini-css-extract-plugin
export var fadeInOut = "_36-3";
export var icon = "_36-4";
export var savedIndicator = "_36-2";
export var savingIndicator = "_36-0";
export var spin = "_36-1";